export const GET_CACHE_KEYS = 'GET_CACHE_KEYS'
export const GET_CACHE_KEYS_SUCCESS = 'GET_CACHE_KEYS_SUCCESS'
export const GET_CACHE_KEYS_FAILED = 'GET_CACHE_KEYS_FAILED'

export const DELETE_CACHE_KEYS = 'DELETE_CACHE_KEYS'
export const DELETE_CACHE_KEYS_SUCCESS = 'DELETE_CACHE_KEYS_SUCCESS'
export const DELETE_CACHE_KEYS_FAILED = 'DELETE_CACHE_KEYS_FAILED'
